export default __webpack_public_path__ + "static/blit-bba19c178f9fcbf168fc31f25793e57c.png";